import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";

const omitSample = [];

const UserRightsContext = createContext();
const UserRightsProvider = ({ children }) => {
  const userInfo = useMemo(
    () => JSON.parse(localStorage.getItem("userInfo")),
    []
  );

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const requestRights = useCallback(() => {
    if (!userInfo?.userId) return;
    Promise.all([
      fetch(
        `${process.env.REACT_APP_API2_URL}/User/UserRights_GetUserRights?idUser=${userInfo?.userId}&idApp=0`
      ).then((response) => {
        return response.json();
      }),
      fetch(
        `${process.env.REACT_APP_API2_URL}/User/UserRights_GetUserRights?idUser=${userInfo?.userId}&idApp=5`
      ).then((response) => {
        return response.json();
      }),
      fetch(
        `${process.env.REACT_APP_API2_URL}/User/UserRights_GetUserRights?idUser=${userInfo?.userId}&idApp=6`
      ).then((response) => {
        return response.json();
      }),
      fetch(
        `${process.env.REACT_APP_API2_URL}/User/UserRights_GetUserRights?idUser=${userInfo?.userId}&idApp=7`
      ).then((response) => {
        return response.json();
      }),
    ])
      .then((userRights) => {
        const rights = userRights
          ?.flat(Infinity)
          ?.map((item) => item.IdRight ?? item.idRight)
          .filter((item) => item !== undefined && !omitSample.includes(item));
        setData(rights);
        if (!rights.includes(354)) {
          localStorage.removeItem("userInfo");
          window.location.replace("/login");
          window.history.pushState(null, null, "/login");
        }
      })
      .catch((error) => setError(error.message))
      .finally(() => setLoading(false));
  }, [userInfo]);

  useEffect(() => {
    requestRights();
  }, [requestRights]);


  return (
    <UserRightsContext.Provider value={{ data, loading, error }}>
      {children}
    </UserRightsContext.Provider>
  );
};

const useUserRights = () => {
  const context = useContext(UserRightsContext);
  if (context === undefined) {
    throw new Error("useData must be used within a DataProvider");
  }
  return context;
};

const useHasRights = (...ids) => {
  const { data } = useUserRights();
  return ids.some((id) => data?.includes(id));
};

export { UserRightsProvider, useHasRights, useUserRights };
